export const API_PATHS = {
  DATA: '/user/gamification/data',

  USER_PROGRESS: '/user/gamification/progress',
  USER_MISSIONS_PROGRESSES: '/user/missions/progresses',

  JOURNEYS: '/user/journeys'
} as const

export const PATHS_WITH_INITIAL_DATA = [
  API_PATHS.DATA,
  API_PATHS.USER_PROGRESS,
  API_PATHS.JOURNEYS,
  API_PATHS.USER_MISSIONS_PROGRESSES
] as const
